<ion-row [ngStyle]="isShowGraph ? { display: 'flex' } : { display: 'none' }">
  <ion-col>
    <ion-card appLockIcon [isLock]="isLock" class="ion-padding">
      <ion-card-header *ngIf="shouldShowSelector; else normalTitle">
        <ion-grid class="ion-no-padding">
          <div class="grid-container" style="width: 100%; display: grid; grid-template-columns: auto 1fr; align-items: center">
            <div class="grid-title" style="display: flex; justify-content: start; align-items: center">
              <ion-card-title id="col-title-name">
                {{ title }}
                <ion-icon *ngIf="infoPopover" (click)="infoPopover($event)" class="icon-vertical-center info-icon" name="information-circle-outline"></ion-icon>
              </ion-card-title>
            </div>
            <div id="col-selector" style="display: flex; justify-content: flex-end; align-items: center">
              <ion-select
                [multiple]="multipleSelector"
                [value]="selectedName"
                style="font-size: 16px; color: var(--ion-color-primary); text-align: justify"
                [interface]="selectInterface"
                (ionChange)="changeSelectedGraph($event)"
                #ionGraphSelector
                mode="md"
              >
                <ion-select-option
                  *ngFor="let selName of selectorName; index as i"
                  [value]="selName"
                  >{{ configDataService?.DISPLAY_LANGUAGE?.DYNAMIC_SELECTOR_NAME?.[selName] || selName }}</ion-select-option
                >
              </ion-select>
            </div>
          </div>
        </ion-grid>
      </ion-card-header>
      <ng-template #normalTitle>
        <ion-card-header>
          <ion-grid>
            <ion-row class="ion-align-items-center">
              <ion-col>
                <ion-card-title>
                  {{ title }}
                  <ion-icon *ngIf="infoPopover" (click)="infoPopover($event)" class="icon-vertical-center info-icon" name="information-circle-outline"></ion-icon>
                </ion-card-title>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-header>
      </ng-template>
      <ion-card-content class="ion-no-margin">
        <ion-row>
          <ion-col appLockBlur [isLock]="isLock">
            <app-generic-echart [chartLoading$]="chartLoading$" [chartOption]="chartOption" [chartOption$]="chartOption$"></app-generic-echart>
          </ion-col>
        </ion-row>
      </ion-card-content>
    </ion-card>
  </ion-col>
</ion-row>
